import {z} from 'zod';

const leadSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email_address: z.string().email(),
  region_code: z.string(),
  post_code: z.string(),
  country_code: z.string(),
  mobile_phone: z.string(),
  vehicle_interested_in: z.string(),
  tracking_code_did: z.number().int(),
  lead_type: z.string(),
  sub_brand: z.string(),
  brand: z.string(),
  source: z.string(),
  model_1: z.string(),
  model_2: z.string(),
});

const tradeInEvaluationSchema = z.object({
  redbookcode: z.string().trim(),
  rbid: z.string().trim(),
  makecode: z.string().trim(),
  familycode: z.string().trim(),
  vehicletype: z.string().trim(),
  year: z.string(),
  month: z.string(),
  sequenceno: z.string().trim(),
  description: z.string().trim(),
  newvehicleflag: z.string(),
  importflag: z.string(),
  limitededition: z.string(),
  series: z.string().trim(),
  seriesmodelyear: z.string().trim(),
  badge: z.string().trim(),
  badge2nd: z.array(z.string()),
  bodystyle: z.string().trim(),
  bodyconfig: z.array(z.string()),
  wheelbaseconfig: z.array(z.string()),
  roofline: z.array(z.string()),
  extrainfo: z.array(z.string()),
  drive: z.string().trim(),
  geartype: z.string().trim(),
  gearlocation: z.string().trim(),
  gearnum: z.string().trim(),
  doornum: z.string().trim(),
  enginesize: z.string().trim(),
  enginedesc: z.string().trim(),
  cylinders: z.string().trim(),
  fueltype: z.string().trim(),
  induction: z.string().trim(),
  greenhouserating: z.array(z.string()),
  airpollutionrating: z.array(z.string()),
  overallgreenstarrating: z.array(z.string()),
  co2: z.string().trim(),
  co2urban: z.string().trim(),
  co2extraurban: z.string().trim(),
  fuelurban: z.string().trim(),
  fuelextraurban: z.string().trim(),
  fuelcombined: z.string().trim(),
  emissionstandard: z.string().trim(),
  maxethanolblend: z.array(z.string()),
  vfactsclass: z.string().trim(),
  vfactssegment: z.string().trim(),
  vfactsprice: z.string().trim(),
  ancaprating: z.string().trim(),
  avgkm: z.string().trim(),
  gdkm: z.string().trim(),
  avgwhs: z.string().trim(),
  avgretail: z.string().trim(),
  goodwhs: z.string().trim(),
  goodretail: z.string().trim(),
  tradeinmin: z.string(),
  tradeinmax: z.string(),
  privatemin: z.string(),
  privatemax: z.string(),
  rego_no: z.string().trim(),
  state: z.string(),
  make: z.string().trim(),
  model: z.string().trim(),
  variant: z.string().trim(),
  vin: z.any().nullable(),
});

const SurveyAnswer = z.object({
  usage: z.string(),
  no_of_passengers: z.string(),
  towing_vehicle: z.string(),
  vehicle_trade: z.string(),
  reason_for_interest: z.string(),
  energy_options: z.string(),
  charger_installed: z.string(),
  charger_access: z.string(),
  distance_travelled: z.string(),
  recommended_model_1: z.string(),
  recommended_model_2: z.string(),
  survey_url: z.string(),
});

export const SalesforceSurveySchema = z.object({
  lead: leadSchema,
  trade_in_evaluation: tradeInEvaluationSchema,
  survey_answers: SurveyAnswer,
});

export type SalesforceSurvey = z.infer<typeof SalesforceSurveySchema>;
